<template>
    <AppModal grid size="small" :backdrop="true">
        <AppModalContent>
            <AppModalBody>
                <div class="flex flex-col overflow-y-auto py-4">
                    <p class="font-bold">{{ state.label }}</p>

                    <NewMessageState
                        v-if="state.key === 'new_message'"
                        @handleChangeState="handleIntentToCreateGroup"
                    />

                    <AddMemberState v-if="state.key === 'add_member'" />

                    <CreateGroupState
                        v-if="state.key === 'create_group'"
                        @backToAddMembers="() => (state = states.add_member)"
                    />

                    <AppModalFooter
                        :isFormkit="state.key === 'new_message'"
                        @onHideModal="() => toggleModal('new_message')"
                        @onSubmit="handleNext"
                        cancelBtnText="Cancel"
                        :btnLoading="loadingState.startChat ? (state.key === 'new_message' ? 'cancel' : 'save') : ''"
                        :btnDisabled="state.key !== 'new_message' && groupMembers.length<2 ? 'save' : ''"
                        saveBtnText="Next"
                        class="xs:!hidden !px-0"
                        variant="secondary"
                        position="sm:!sticky"
                    >
                    </AppModalFooter>
                </div>
            </AppModalBody>
        </AppModalContent>
    </AppModal>
</template>

<script setup>
import { ref } from "vue";
import { AppModal, AppModalBody, AppModalContent, AppModalFooter } from "@/components/appComponents/modal";

import NewMessageState from "./NewMessageState.vue";
import { useChatStore } from "@/stores/chatStore";
import CreateGroupState from "./CreateGroupState.vue";
import AddMemberState from "./AddMemberState.vue";
import { useEmitter } from "@/composables/useEmitter";
import useToggleModal from "@/composables/useToggleModal";
import { groupMembers } from "./globalStates";

// [info]: constants
const states = {
    new_message: { label: "New message", key: "new_message" },
    add_member: { label: "Add members", key: "add_member" },
    create_group: { label: "Create Group", key: "create_group" },
};

// [info]: states
const state = ref(states.new_message);

// [info]: composable
const { loadingState } = useChatStore();
const emitter = useEmitter();
const { toggleModal } = useToggleModal();

// [info]: methods
const handleIntentToCreateGroup = () => {
    state.value = states.add_member;
};

const handleNext = () => {
    if (state.value.key === "create_group") {
        emitter.emit("create_group");
    } else {
        state.value = states.create_group;
    }
};
</script>
